import React from 'react';
import { Button } from "@/components/ui/button";
import { Cookie, Settings, X } from 'lucide-react';
import { useCookieConsent } from '@/hooks/useCookieConsent';
import CookieConsentModal from '@/components/guest/CookieConsentModal';

const CookieBanner = () => {
  const {
    showBanner,
    showModal,
    setShowModal,
    acceptAll,
    acceptEssential,
    customizeSettings
  } = useCookieConsent();

  if (!showBanner) return null;

  return (
    <div className="fixed bottom-0 left-0 right-0 z-50 bg-white border-t border-gray-200 shadow-lg">
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
        <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
          <div className="flex items-start gap-3 flex-1">
            <div className="w-10 h-10 bg-amber-100 rounded-full flex items-center justify-center flex-shrink-0">
              <Cookie className="w-5 h-5 text-amber-600" />
            </div>
            <div className="flex-1">
              <h3 className="font-semibold text-gray-900 mb-1">🍪 We use cookies</h3>
              <p className="text-sm text-gray-600 leading-relaxed">
                We use cookies to enhance your experience and analyze our website traffic.
                By continuing to browse, you agree to our use of cookies.{' '}
                <button
                  onClick={customizeSettings}
                  className="text-amber-600 hover:underline font-medium"
                >
                  Learn more
                </button>
              </p>
            </div>
          </div>

          <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
            <Button
              onClick={acceptEssential}
              variant="outline"
              size="sm"
              className="border-gray-300 text-gray-700 hover:bg-gray-50"
            >
              Essential Only
            </Button>
            <Button
              onClick={customizeSettings}
              variant="outline"
              size="sm"
              className="border-amber-300 text-amber-700 hover:bg-amber-50"
            >
              <Settings className="w-4 h-4 mr-2" />
              Customize
            </Button>
            <Button
              onClick={acceptAll}
              size="sm"
              className="bg-gradient-to-r from-amber-600 to-orange-600 hover:from-amber-700 hover:to-orange-700 text-white"
            >
              Accept All
            </Button>
          </div>
        </div>
      </div>

      {/* Cookie Consent Modal */}
      <CookieConsentModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onAcceptAll={acceptAll}
        onAcceptEssential={acceptEssential}
        onCustomize={customizeSettings}
      />
    </div>
  );
};

export default CookieBanner;